export default "__VITE_ASSET__CVhNz7jP__"